package com.devi3east.bashbuddy.features.detail.ui

import com.devi3east.bashbuddy.features.common.data.domain.entities.RecipeItem

data class RecipeDetailUiState(
    val recipesDetail: RecipeItem? = null,
    val recipesDetailIsLoading: Boolean = true,
    val recipesDetailError: String? = null,
)
